









import { Component, Prop, Vue } from 'vue-property-decorator';
import { IDivider } from '@/editor/types';
import { EBlockWidth, ERowType } from '@/editor/types/enums';

@Component
export default class EditorNodeDivider extends Vue {
  @Prop() node: IDivider;
  @Prop() rowType: ERowType;
  @Prop() blockWidthClass: EBlockWidth;

  get dividerType(): string {
    return this.node?.dividerType?.toLowerCase();
  }

  get dividerPadding(): string {
    return `padding-${this.node?.dividerPadding?.toLowerCase()}`;
  }

  get rowTypeClass(): string {
    return `row-type-${this.rowType?.toLowerCase()}`;
  }
}
